<div
  *ngIf="session"
  class="w-full lg:max-w-full lg:flex login-page"
  class="w-full lg:max-w-full lg:flex login-page"
>
  <div
    class="bg-cover bg-center bg-no-repeat lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r pt-6 w-full card-form"
    style="
      background-image: url('assets/img/01-BG_AC_Force_N.png');
      background-size: cover;
      background-position: center;
      background-attachment: fixed;
    "
  >
    <div class="w-4/5 grid-cols-1 flex place-content-center">
      <app-card-form style="opacity: 1">
        <div id="page-one" *ngIf="pageOne">
          <div class="flex justify-between mb-10">
            <div
              class="logo-icon"
              style="background-image: url('assets/img/logo_unchk.png')"
            ></div>
            <div
              class="logo-icon"
              style="background-image: url('assets/img/logo_master_card.png')"
            ></div>
          </div>
          <div class="flex justify-center items-center">
            <div class="text-center">
              <span class="font-bold text-2xl">
                FORMULAIRE DE CANDIDATURE
              </span>
              <br />
              <!-- Certificat de compétences en {{ appelName }} -->
              Programme Force-N
            </div>
          </div>
          <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
          <div class="flex justify-center items-center">
            <div class="text-center">
              <span class="underline text-blue-800"
                ><a
                  href="https://force-n.sn/le-programme-daccompagnement/"
                  target="_blank"
                  >Vous souhaitez en savoir plus avant de candidater? Cliquez
                  ici pour obtenir plus de détails sur ce programme .</a
                >
              </span>
              <br />
              <br />
              <br />
              <span class="font-bold text-2xl">
                Délai limite pour le dépôt des dossiers de candidature
              </span>
              <br />
              <br />
              {{ appelCloseDate | date : "EEEE d MMMM y, à " }} 23h:59mn
            </div>
          </div>
        </div>

        <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
          <form [formGroup]="soumissionForm" class="space-y-6">
            <div *ngIf="pageOne">
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
              <!-- <p class="text-center">
                Les correspondances, les certificats de réussite, l'accès aux
                plateformes de formation et les badges seront générés à partir
                des informations personnelles soumises <br />
                ci-dessous. Veuillez donc fournir des informations correctes et
                appropriées.
              </p> -->
              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl"
                  >I. INFORMATIONS PERSONNELLES</span
                >
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="grid md:grid-cols-3 md:gap-6">
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Prénom - Nom &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="
                        isFieldInvalid('firstname') ||
                        isFieldInvalid('lastname')
                      "
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group">
                  <input
                    type="text"
                    id="prenom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                    formControlName="firstname"
                    [style.border]="
                      isFieldInvalid('firstname') ? '2px solid #eb1c1c' : ''
                    "
                  />
                  <div class="mt-3"><p>Prénom</p></div>
                </div>
                <div class="relative z-0 w-full group">
                  <input
                    type="text"
                    id="nom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                    formControlName="lastname"
                    [style.border]="
                      isFieldInvalid('lastname') ? '2px solid #eb1c1c' : ''
                    "
                  />
                  <div class="mt-3"><p>Nom</p></div>
                </div>
              </div>
              <div class="relative">
                <div class="grid lg:grid-cols-3 gap-6 my-6">
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:flex lg:me-3">
                        Date de naissance &nbsp;
                        <p style="color: red">*</p>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedDate')"
                        style="color: #eb1c1c"
                      >
                        Champ requis!
                      </div>
                      <!-- <div *ngIf="checkValidAge()" style="color: #eb1c1c">
                        L'âge limite de candidature est de 35 ans !
                      </div> -->
                    </div>
                  </div>
                  <div class="col-span-2">
                    <div class="flex justify-between gap-3">
                      <div class="w-full">
                        <input
                          type="date"
                          formControlName="selectedDate"
                          id="year"
                          class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                          [style.border]="
                            isFieldInvalid('selectedDate')
                              ? '2px solid #eb1c1c'
                              : ''
                          "
                        />

                        <div class="mt-3">
                          <p>
                            Saisir votre date de naissance ou vous pouvez
                            directement selectionner la date dans l'agenda.
                          </p>
                        </div>
                      </div>
                      <!-- <div class="w-full">
                        <select
                          formControlName="selectedDay"
                          id="days"
                          class="bg-white h-12 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          [style.border]="
                            isFieldInvalid('selectedDay')
                              ? '2px solid #eb1c1c'
                              : ''
                          "
                        >
                          <option *ngFor="let day of days" [value]="day.id">
                            {{ day.id }}
                          </option>
                        </select>
                        <div class="mt-3"><p>Jour</p></div>
                      </div> -->

                      <!-- <div class="w-full">
                        <select
                          formControlName="selectedMounth"
                          id="mounth"
                          class="bg-white h-12 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          [style.border]="
                            isFieldInvalid('selectedMounth')
                              ? '2px solid #eb1c1c'
                              : ''
                          "
                        >
                          <option *ngFor="let month of months" [value]="month.id">
                            {{ month.name }}
                          </option>
                        </select>
                        <div class="mt-3"><p>Mois</p></div>
                      </div> -->

                      <!-- <div class="w-full">
                        <select
                          formControlName="selectedYear"
                          id="year"
                          class="bg-white h-12 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          [style.border]="
                            isFieldInvalid('selectedYear')
                              ? '2px solid #eb1c1c'
                              : ''
                          "
                        >
                          <option *ngFor="let year of years" [value]="year.year">
                            {{ year.year }}
                          </option>
                        </select>
                        <div class="mt-3"><p>Année</p></div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 md:gap-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Sexe &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedSexe')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center ps-4">
                    <input
                      formControlName="selectedSexe"
                      id="bordered-radio"
                      type="radio"
                      value="Homme"
                      name="selectedSexe"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('selectedSexe')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="bordered-radio"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Masculin</label
                    >
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center ps-4">
                    <input
                      formControlName="selectedSexe"
                      id="bordered-radio"
                      value="Féminin"
                      type="radio"
                      name="selectedSexe"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('selectedSexe')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="bordered-radio"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Féminin</label
                    >
                  </div>
                </div>
              </div>
              <div class="grid md:grid-cols-3 md:gap-6">
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Numéro de téléphone &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="
                        isFieldInvalid('phoneNumber') ||
                        isFieldInvalid('phoneCode')
                      "
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                    <!-- <div *ngIf="checkValideCallNumber()" style="color: #eb1c1c">
                      Tapez seulement des nombres!
                    </div> -->
                  </div>
                </div>
                <div class="relative z-0 w-full group">
                  <select
                    type="text"
                    id="prenom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                    formControlName="phoneCode"
                    [style.border]="
                      isFieldInvalid('phoneCode') ? '2px solid #eb1c1c' : ''
                    "
                  >
                    <option
                      *ngFor="let phonecode of phoneCode"
                      [value]="phonecode.phoneCode"
                    >
                      {{ phonecode.phoneCode }}
                    </option>
                  </select>
                  <div class="mt-3"><p>Indicatif pays</p></div>
                </div>
                <div class="relative z-0 w-full group">
                  <input
                    type="tel"
                    id="phoneNumber"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                    formControlName="phoneNumber"
                    onlyNumber
                    [style.border]="
                      isFieldInvalid('phoneNumber') ? '2px solid #eb1c1c' : ''
                    "
                  />
                  <div class="mt-3"><p>Numéro de téléphone</p></div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Ce numéro est-il disponible sur <br />
                      Whatsapp? &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('isWhatsApp')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center ps-4">
                    <input
                      formControlName="isWhatsApp"
                      id="bordered-radio-1"
                      type="radio"
                      value="OUI"
                      name="isWhatsApp"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('isWhatsApp') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="bordered-radio-1"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Oui</label
                    >
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center ps-4">
                    <input
                      formControlName="isWhatsApp"
                      checked
                      id="bordered-radio-1"
                      type="radio"
                      value="NON"
                      name="isWhatsApp"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('isWhatsApp') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="bordered-radio-1"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Non</label
                    >
                  </div>
                </div>
              </div>

              <div
                class="grid md:grid-cols-3 md:gap-6"
                *ngIf="showWhatsAppNumberFields"
              >
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Numéro Whatsapp &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="
                        isFieldInvalid('whatsAppNumber') ||
                        isFieldInvalid('phoneCodeForWhatsApp')
                      "
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                    <!-- <div *ngIf="checkValideCallNumber()" style="color: #eb1c1c">
                      Tapez seulement des nombres!
                    </div> -->
                  </div>
                </div>
                <div class="relative z-0 w-full group">
                  <select
                    type="text"
                    id="prenom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                    formControlName="phoneCodeForWhatsApp"
                    [style.border]="
                      isFieldInvalid('phoneCodeForWhatsApp')
                        ? '2px solid #eb1c1c'
                        : ''
                    "
                  >
                    <option
                      *ngFor="let phonecode of phoneCodeWhatsapp"
                      [value]="phonecode.phoneCode"
                    >
                      {{ phonecode.phoneCode }}
                    </option>
                  </select>
                  <div class="mt-3"><p>Indicatif pays</p></div>
                </div>
                <div class="relative z-0 w-full group">
                  <input
                    type="tel"
                    id="whatsAppNumber"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                    formControlName="whatsAppNumber"
                    onlyNumber
                    [style.border]="
                      isFieldInvalid('whatsAppNumber')
                        ? '2px solid #eb1c1c'
                        : ''
                    "
                  />
                  <div class="mt-3"><p>Numéro de téléphone</p></div>
                </div>
              </div>

              <div formGroupName="emailGroup">
                <div class="grid md:grid-cols-3 gap-6 my-6">
                  <div class="relative z-0 w-full mb-5 group">
                    <div class="col-span-1 label">
                      <div class="lg:flex lg:me-3">
                        Adresse email &nbsp;
                        <p style="color: #ff0000">*</p>
                      </div>
                      <!-- <div
                        *ngIf="isFieldInvalid('email')  && soumissionForm.get('email')?.errors?.['required']"
                        style="color: #eb1c1c"
                      >
                        Champ requis!
                      </div> -->
                      <div
                        *ngIf="isFieldInvalidForMails('emailGroup.email')"
                        style="color: #eb1c1c"
                      >
                        Champ requis!
                      </div>
                      <div
                        *ngIf="isMailFieldInvalid('email')"
                        style="color: #eb1c1c"
                      >
                        Format de l'email invalide.
                      </div>
                      <!-- <div
                        *ngIf="isFieldInvalid('email') && isMailFieldInvalid()"
                        style="color: #eb1c1c"
                      >
                        Mettez un mail valide!
                      </div> -->

                      <!-- <div *ngIf="isEmailMatched()" style="color: #eb1c1c">
                        Mettez des mails identiques!
                      </div> -->
                      <!-- <div
                        *ngIf="isMailFieldInvalid('email')"
                        style="color: #eb1c1c"
                      >
                        Mettez un mail valide!
                      </div> -->
                    </div>
                  </div>
                  <div class="col-span-2 label">
                    <div class="relative z-0 w-full mb-5 group">
                      <input
                        type="text"
                        id="email"
                        class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                        placeholder="Par ex : monnom@exemple.com"
                        formControlName="email"
                        [style.border]="
                          isFieldInvalid('emailGroup.email')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                    </div>
                  </div>
                </div>
                <div class="grid md:grid-cols-3 gap-6 my-6">
                  <div class="relative z-0 w-full mb-5 group">
                    <div class="col-span-1 label">
                      <div class="lg:flex lg:me-3"></div>
                    </div>
                    <!-- <div
                      *ngIf="isFieldInvalid('confirmEmail')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                    <div *ngIf="soumissionForm.errors" style="color: #eb1c1c">
                      {{ soumissionForm.errors["emailConfirm"] }}
                    </div> -->
                    <div
                      *ngIf="isFieldInvalidForMails('emailGroup.confirmEmail')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!.
                    </div>
                    <div
                      *ngIf="isMailFieldInvalid('confirmEmail')"
                      style="color: #eb1c1c"
                    >
                      Format de l'email invalide.
                    </div>

                    <div
                      *ngIf="showEmailErrors$ | async"
                      style="color: #eb1c1c"
                    >
                      Mettez des mails identiques!
                    </div>
                  </div>
                  <div class="col-span-2 label">
                    <div class="relative z-0 w-full mb-5 group">
                      <input
                        type="email"
                        id="confirmEmail"
                        class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                        formControlName="confirmEmail"
                        [style.border]="
                          isFieldInvalid('emailGroup.confirmEmail')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                      <div class="mt-3">
                        <p>
                          Pour être sûr de bien recevoir nos mails, merci d'utiliser des adresses type Gmail,
                          Evitez les adresses Outlook, Yahoo, Hotmail et professionnelles.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Nationalité &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedCountry')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>

                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center ps-4">
                    <input
                      formControlName="selectedCountry"
                      id="bordered-radio-2"
                      type="radio"
                      value="Sénégal"
                      name="selectedCountry"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('selectedCountry')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="bordered-radio-2"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Sénégalaise</label
                    >
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center ps-4">
                    <input
                      formControlName="selectedCountry"
                      checked
                      id="bordered-radio-2"
                      type="radio"
                      value="Autre"
                      name="selectedCountry"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('selectedCountry')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="bordered-radio-2"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Autre</label
                    >
                  </div>
                </div>
              </div>
              <!-- if other coutry -->

              <div
                class="grid md:grid-cols-3 gap-6 my-6"
                *ngIf="
                  soumissionForm.get('selectedCountry')?.value != 'Sénégal' &&
                  (soumissionForm.get('selectedCountry')?.value != null ||
                    soumissionForm.get('selectedCountry')?.value != undefined)
                "
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Précisez votre nationalité &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('otherCountry')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      type="text"
                      id="otherCountry"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      formControlName="otherCountry"
                      [style.border]="
                        isFieldInvalid('otherCountry')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let country of countries"
                        [value]="country.name"
                      >
                        {{ country.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl"
                  >II. SITUATION ACADEMIQUE ET PROFESSIONNELLE</span
                >
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Statut Actuel &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('professionnalSituation')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-3">
                  <div>
                    <input
                      type="radio"
                      id="jobLess"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="professionnalSituation"
                      value="Diplômé/Sans emploi"
                      name="professionnalSituation"
                      [style.border]="
                        isFieldInvalid('professionnalSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="jobLess"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Diplômé/Sans emploi</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="student"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="professionnalSituation"
                      value="Etudiant"
                      name="professionnalSituation"
                      [style.border]="
                        isFieldInvalid('professionnalSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="student"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Etudiant</label
                    >
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-3">
                  <div>
                    <input
                      type="radio"
                      id="otherStatus"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="professionnalSituation"
                      value="Autre ( Salarié, non-diplômé, auto-emploi...)"
                      name="professionnalSituation"
                      [style.border]="
                        isFieldInvalid('professionnalSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="otherStatus"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Autre ( Salarié, non-diplômé, auto-emploi...)</label
                    >
                  </div>
                </div>
              </div>
              <div *ngIf="showDegreeDiv" class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Diplôme le plus élevé obtenu (ou équivalent) &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedDiplome')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="selectedDiplome"
                      id="countries"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('selectedDiplome')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let diplome of diplomes"
                        [value]="diplome.name"
                      >
                        {{ diplome.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div *ngIf="showSeriesDiv" class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Précisez votre série au Bac &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedSerie')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="selectedSerie"
                      id="countries"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('selectedSerie')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option *ngFor="let serie of series" [value]="serie.name">
                        {{ serie.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div
                *ngIf="showDisciplineDivBTS"
                class="grid md:grid-cols-3 gap-6 my-6"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Précisez la discipline de votre DUT/BTS [ou diplômes
                      équivalents] &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedDisciplineForBTS')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="selectedDisciplineForBTS"
                      id="countries"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('selectedDisciplineForBTS')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let discipline of disciplines"
                        [value]="discipline.name"
                      >
                        {{ discipline.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div
                *ngIf="showDisciplineDivLicence"
                class="grid md:grid-cols-3 gap-6 my-6"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Précisez la discipline de votre Licence/Master [ou
                      diplômes équivalents] &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedDisciplineForLicence')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="selectedDisciplineForLicence"
                      id="countries"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('selectedDisciplineForLicence')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let discipline of disciplines"
                        [value]="discipline.name"
                      >
                        {{ discipline.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div
                *ngIf="showDisciplineDivM1"
                class="grid md:grid-cols-3 gap-6 my-6"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Précisez la discipline de votre Licence/Master [ou
                      diplômes équivalents] &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedDisciplineForM1')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="selectedDisciplineForM1"
                      id="countries"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('selectedDisciplineForM1')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let discipline of disciplines"
                        [value]="discipline.name"
                      >
                        {{ discipline.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div
                *ngIf="showDisciplineDivM2"
                class="grid md:grid-cols-3 gap-6 my-6"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Précisez la discipline de votre Licence/Master [ou
                      diplômes équivalents] &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedDisciplineForM2')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="selectedDisciplineForM2"
                      id="countries"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('selectedDisciplineForM2')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let discipline of disciplines"
                        [value]="discipline.name"
                      >
                        {{ discipline.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                *ngIf="showDisciplineDivDoctorat"
                class="grid md:grid-cols-3 gap-6 my-6"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Précisez la discipline de votre Doctorat &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedDisciplineForDoctorat')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="selectedDisciplineForDoctorat"
                      id="countries"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('selectedDisciplineForDoctorat')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let discipline of disciplines"
                        [value]="discipline.name"
                      >
                        {{ discipline.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                *ngIf="showStudentDiv"
                class="grid md:grid-cols-3 gap-6 my-6"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Indiquez votre niveau actuel d'études &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedStudyLevel')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="selectedStudyLevel"
                      id="countries"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('selectedStudyLevel')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let student of students"
                        [value]="student.name"
                      >
                        {{ student.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                *ngIf="showOtherSituationDiv"
                class="grid md:grid-cols-3 gap-6 my-6"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Précisez votre statut &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedOtherStatus')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="selectedOtherStatus"
                      id="countries"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('selectedOtherStatus')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let otherstatus of otherStatus"
                        [value]="otherstatus.name"
                      >
                        {{ otherstatus.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Votre projet à l’issue du certificat &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedGoal')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-3">
                  <div>
                    <input
                      id="continueEtude"
                      type="radio"
                      value="Poursuivre mes études"
                      name="selectedGoal"
                      class="w-6 h-6 mb-2 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="selectedGoal"
                      [style.border]="
                        isFieldInvalid('selectedGoal') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="continueEtude"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Poursuivre mes études
                    </label>
                  </div>
                  <div>
                    <input
                      formControlName="selectedGoal"
                      id="selectedGoal"
                      type="radio"
                      value="Chercher un Job"
                      name="selectedGoal"
                      class="w-6 h-6 mb-2 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('selectedGoal') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="selectedGoal"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >
                      Chercher un Job
                    </label>
                  </div>
                  <div>
                    <input
                      formControlName="selectedGoal"
                      id="selectedGoal"
                      type="radio"
                      value="Aucun de ces projets"
                      name="selectedGoal"
                      class="w-6 h-6 mb-2 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('selectedGoal') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="selectedGoal"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >
                      Aucun de ces projets
                    </label>
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-3">
                  <div>
                    <input
                      formControlName="selectedGoal"
                      id="selectedGoal"
                      type="radio"
                      value="Lancer mon projet"
                      name="selectedGoal"
                      class="w-6 h-6 mb-2 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('selectedGoal') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="selectedGoal"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >
                      Lancer mon projet
                    </label>
                  </div>
                  <div>
                    <input
                      formControlName="selectedGoal"
                      id="selectedGoal"
                      type="radio"
                      value="Retourner dans mon entreprise"
                      name="selectedGoal"
                      class="w-6 h-6 mb-2 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('selectedGoal') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="selectedGoal"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Retourner dans mon entreprise
                    </label>
                  </div>
                </div>
              </div> -->

              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl">III. INCLUSION</span>
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Région de résidence &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedRegion')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="selectedRegion"
                      id="cities"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('selectedRegion')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let region of regions"
                        [value]="region.name"
                      >
                        {{ region.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div
                class="grid lg:grid-cols-3 gap-6 my-6"
                *ngIf="showZoneOfResidenceDiv()"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Zone de résidence &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedZone')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2">
                  <select
                    formControlName="selectedZone"
                    id="zone"
                    class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    [style.border]="
                      isFieldInvalid('selectedZone') ? '2px solid #eb1c1c' : ''
                    "
                  >
                    <option *ngFor="let zone of zones" [value]="zone.name">
                      {{ zone.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div
                class="grid lg:grid-cols-3 gap-6 my-6"
                *ngIf="showSpecifyDiv()"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Précisez la région de résidence &nbsp;
                    </div>
                    <div
                      *ngIf="isFieldInvalid('specifyRegion')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2">
                  <input
                    formControlName="specifyRegion"
                    id="specifyRegion"
                    class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  />
                </div>
              </div>

              <div class="grid lg:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Êtes-vous en situation de handicap? &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('inHandicapSituation')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2">
                  <select
                    formControlName="inHandicapSituation"
                    id="inHandicapSituation"
                    class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    [style.border]="
                      isFieldInvalid('inHandicapSituation')
                        ? '2px solid #eb1c1c'
                        : ''
                    "
                  >
                    <option value="Oui">Oui</option>
                    <option value="Non">Non</option>
                  </select>
                </div>
              </div>

              <div
                class="grid md:grid-cols-3 gap-6 my-6"
                *ngIf="showHandicapChoiceRadio"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Avez-vous l'un des handicaps suivants ? &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="
                        chooseAHandicapMoteur &&
                        chooseAHandicapAuditif &&
                        chooseAHandicapVisuel &&
                        chooseAHandicapAutre
                      "
                      style="color: #eb1c1c"
                    >
                      Choisi un handicap!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-3">
                  <div>
                    <input
                      type="checkbox"
                      id="handicapVisuel"
                      class="h-5 w-5 m-3 rounded"
                      formControlName="handicaps_visuel"
                      [style.border]="
                        isFieldInvalid('handicaps_visuel')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="handicapVisuel"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Handicap visuel</label
                    >
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="handicapMoteur"
                      class="h-5 w-5 m-3 rounded"
                      formControlName="handicaps_moteur"
                      [style.border]="
                        isFieldInvalid('handicaps_moteur')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="handicapMoteur"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Handicap moteur</label
                    >
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-3">
                  <div>
                    <input
                      type="checkbox"
                      id="handicapAuditif"
                      class="h-5 w-5 m-3 rounded"
                      formControlName="handicaps_auditif"
                      [style.border]="
                        isFieldInvalid('handicaps_auditif')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="handicapAuditif"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Handicap auditif</label
                    >
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="handicapAutre"
                      class="h-5 w-5 m-3 rounded"
                      formControlName="handicaps_autre"
                      [style.border]="
                        isFieldInvalid('handicaps_autre')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="handicapAutre"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Autre Handicap</label
                    >
                  </div>
                </div>
              </div>

              <div class="grid lg:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Êtes-vous dans l’une des situations suivantes? &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedSituation')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-3">
                  <div>
                    <input
                      type="radio"
                      id="selectedSituation1"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="selectedSituation"
                      name="selectedSituation"
                      value="Réfugié"
                      [style.border]="
                        isFieldInvalid('selectedSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="selectedSituation1"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Réfugié</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="selectedSituation2"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="selectedSituation"
                      name="selectedSituation"
                      value="Déplacé"
                      [style.border]="
                        isFieldInvalid('selectedSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="selectedSituation2"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Déplacé</label
                    >
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="selectedSituation3"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="selectedSituation"
                      name="selectedSituation"
                      value="Non concerné"
                      [style.border]="
                        isFieldInvalid('selectedSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="selectedSituation3"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Non concerné</label
                    >
                  </div>
                </div>
              </div>

              <!-- <br /><br /><br />

              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl"
                  >IV. NIVEAU DE CONNAISSANCE ET DE MAITRISE DES PREREQUIS DU
                  CERTIFICAT</span
                >
              </div> -->
              <!-- <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" /> -->
              <hr class="h-1 my-8 bg-green-500 border-0 dark:bg-gray-700" />

              <!-- <div
                *ngFor="let prerequisite of prerequisites; let i = index"
                class="grid lg:grid-cols-3 gap-6 my-6"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      <p style="color: red">*</p>
                    </div>
                    <div *ngIf="isFieldInvalid('')" style="color: #eb1c1c">
                      Champ requis!
                    </div>
                  </div>
                </div>

                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      id="countries"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('') ? '2px solid #eb1c1c' : ''
                      "
                    >
                      <option
                        *ngFor="let rule of prerequisite.rules"
                        [value]="rule.maxScore"
                        class="text-gray-600"
                      >
                      </option>
                    </select>
                  </div>
                </div>
              </div> -->
              <div
                class="flex justify-center items-center"
                *ngIf="fillPageOneFields"
                style="color: #eb1c1c"
              >
                Veuillez renseigner tous les champs requis!
              </div>

              <div class="flex justify-end items-center">
                <button
                  type="submit"
                  class="rounded-md w-48 h-12 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 btn-login"
                  (click)="switchOnPageTwo()"
                >
                  Suivant
                </button>
              </div>

              <div class="flex justify-center mt-8">
                <div
                  class="logo-icon"
                  style="background-image: url('assets/img/logo_force_n.png')"
                ></div>
              </div>
            </div>

            <!-- La deuxieme Page -->

            <div id="page-two" *ngIf="pageTwo">
              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl">IV. MON PROJET</span>
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
              <span class="text-center font-bold">
                Pour nous permettre de vous aider au mieux dans la
                concrétisation de votre projet personnel et professionnel,
                répondez aux questions suivantes. Répondez également le plus
                sincèrement possible.
              </span>
              <hr class="h-1 my-8 bg-green-500 border-3 dark:bg-green-700" />

              <div class="grid md:grid-cols-3 md:gap-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Je suis intéressé(e) par les métiers du: &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('familyChoice')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group flex flex-col gap-4">
                  <div
                    *ngFor="let family of families"
                    class="flex items-center ps-4"
                  >
                    <input
                      id="familyChoice"
                      type="radio"
                      [value]="family.name"
                      formControlName="familyChoice"
                      name="familyChoice"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('familyChoice')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="familyChoice"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >{{ family.name }}</label
                    >
                  </div>
                  <!-- <div class="flex items-center ps-4">
                    <input
                      id="familyChoice"
                      type="radio"
                      value="e-BUSINESS"
                      formControlName="familyChoice"
                      name="familyChoice"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('familyChoice')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="familyChoice"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >e-BUSINESS</label
                    >
                  </div>
                  <div class="flex items-center ps-4">
                    <input
                      id="familyChoice"
                      type="radio"
                      value="TECHNOLOGIES EMERGENTES ET CYBERSECURITE"
                      formControlName="familyChoice"
                      name="familyChoice"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('familyChoice')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="familyChoice"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >TECHNOLOGIES EMERGENTES ET CYBERSECURITE</label
                    >
                  </div>
                  <div class="flex items-center ps-4">
                    <input
                      id="familyChoice"
                      type="radio"
                      value="INTELLIGENCE ARTIFICIELLE ET DATA"
                      formControlName="familyChoice"
                      name="familyChoice"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('familyChoice')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="familyChoice"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >INTELLIGENCE ARTIFICIELLE ET DATA</label
                    >
                  </div> -->
                </div>
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl"
                  >V. CONNAISSANCES & APTITUDES</span
                >
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div
                *ngFor="let prerequisite of prerequisites; let i = index"
                class="grid lg:grid-cols-3 gap-6 my-6"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      {{ prerequisite.name }}

                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedPrerequisite_' + i)"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>

                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      id="countries"
                      [formControlName]="'selectedPrerequisite_' + i"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('selectedPrerequisite_' + i)
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <!-- <option
                    *ngFor="let rule of prerequisite.rules"
                    [value]="rule.maxScore"
                    class="text-gray-600"
                  >
                    {{ rule.rule }}
                  </option> -->
                      <option
                        *ngFor="let bareme of baremes"
                        [value]="bareme.value"
                        class="text-gray-600"
                      >
                        {{ bareme.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div
                *ngFor="let genericPrerequisite of genList; let i = index"
                class="grid lg:grid-cols-3 gap-6 my-6"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      {{ genericPrerequisite.name }}

                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('selectedgenPrerequisite_' + i)"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>

                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      id="countries"
                      [formControlName]="'selectedgenPrerequisite_' + i"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('selectedgenPrerequisite_' + i)
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <!-- <option
                    *ngFor="let rule of prerequisite.rules"
                    [value]="rule.maxScore"
                    class="text-gray-600"
                  >
                    {{ rule.rule }}
                  </option> -->
                      <option
                        *ngFor="
                          let bareme of genericPrerequisite.genPrerequisLabelDTOS
                        "
                        [value]="bareme.label"
                        class="text-gray-600"
                      >
                        {{ bareme.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div
                class="flex justify-center items-center"
                *ngIf="fillPageTwoFields"
                style="color: #eb1c1c"
              >
                Veuillez renseigner tous les champs requis!
              </div>

              <div class="flex justify-between items-center btn-ctnr">
                <div>
                  <button
                    type="button"
                    class="rounded-md w-48 h-12 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 bg-gray-500"
                    (click)="goBackOnPageOne()"
                  >
                    Retour
                  </button>
                </div>
                <div>
                  <button
                    type="button"
                    class="rounded-md w-48 h-12 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 btn-login"
                    (click)="switchOnPageThree()"
                  >
                    Suivant
                  </button>
                </div>
              </div>

              <div class="flex justify-center mt-8">
                <div
                  class="logo-icon"
                  style="background-image: url('assets/img/logo_force_n.png')"
                ></div>
              </div>
            </div>

            <!-- La troisieme Page -->

            <div id="page-three" *ngIf="pageThree">
              <div class="grid lg:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Disponibilité (temps que vous êtes disposé à consacrer au
                      programme Force-N) &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('availability')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>

                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      id="dispo"
                      formControlName="availability"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('availability')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let timeSlot of availibility"
                        class="text-gray-600"
                        [value]="timeSlot.value"
                      >
                        {{ timeSlot.value }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Comment avez-vous connu ce programme ? &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('mediaSupport')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-3">
                  <div>
                    <input
                      type="radio"
                      id="mediaSupport_0"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="mediaSupport"
                      value="Sur les réseaux ( Linkedin, Facebook..)"
                      name="mediaSupport"
                      [style.border]="
                        isFieldInvalid('mediaSupport')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="mediaSupport_0"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Sur les réseaux ( Linkedin, Facebook..)</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="mediaSupport_1"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="mediaSupport"
                      value="Site web UNCHK"
                      name="mediaSupport"
                      [style.border]="
                        isFieldInvalid('mediaSupport')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="mediaSupport_1"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Site web UNCHK</label
                    >
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="mediaSupport_2"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="mediaSupport"
                      value="Bouche à oreille"
                      name="mediaSupport"
                      [style.border]="
                        isFieldInvalid('mediaSupport')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="mediaSupport_2"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Bouche à oreille</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="mediaSupport_3"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="mediaSupport"
                      value="Autres"
                      name="mediaSupport"
                      [style.border]="
                        isFieldInvalid('mediaSupport')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="mediaSupport_3"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Autres</label
                    >
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-3">
                  <div>
                    <input
                      type="radio"
                      id="mediaSupport_4"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="mediaSupport"
                      value="TV - Radio"
                      name="mediaSupport"
                      [style.border]="
                        isFieldInvalid('mediaSupport')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="mediaSupport_4"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >TV - Radio</label
                    >
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="mediaSupport_5"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="mediaSupport"
                      value="Presse écrite"
                      name="mediaSupport"
                      [style.border]="
                        isFieldInvalid('mediaSupport')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="mediaSupport_5"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Presse écrite</label
                    >
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="mediaSupport_6"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="mediaSupport"
                      value="Site web partenaires"
                      name="mediaSupport"
                      [style.border]="
                        isFieldInvalid('mediaSupport')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <label
                      for="mediaSupport_6"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Site web partenaires</label
                    >
                  </div>
                </div>
              </div>
              <div class="grid lg:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Êtes vous titulaire d'un certificat du programme Force-N?
                      &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('isCertified')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>

                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="isCertified"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('isCertified') ? '2px solid #eb1c1c' : ''
                      "
                    >
                      <option class="text-gray-600" value="OUI">OUI</option>
                      <option class="text-gray-600" value="NON">NON</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 md:gap-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Votre projet à l’issue du programme? &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('yourProject')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group grid grid-rows-3">
                  <div>
                    <input
                      type="radio"
                      id="yourProject_1"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="yourProject"
                      value="Poursuivre mes études"
                      name="yourProject"
                      [style.border]="
                        isFieldInvalid('yourProject') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="yourProject_1"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Poursuivre mes études</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="yourProject_2"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="yourProject"
                      value="Lancer mon entreprise"
                      name="yourProject"
                      [style.border]="
                        isFieldInvalid('yourProject') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="yourProject_2"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Lancer mon entreprise</label
                    >
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="yourProject_3"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="yourProject"
                      value="Chercher un emploi"
                      name="yourProject"
                      [style.border]="
                        isFieldInvalid('yourProject') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="yourProject_3"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Chercher un emploi</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="yourProject_4"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="yourProject"
                      value="Retourner dans mon entreprise"
                      name="yourProject"
                      [style.border]="
                        isFieldInvalid('yourProject') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="yourProject_4"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Retourner dans mon entreprise</label
                    >
                  </div>

                  <div>
                    <input
                      type="radio"
                      id="yourProject_5"
                      class="w-5 h-5 m-3 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      formControlName="yourProject"
                      value="Aucun des projets"
                      name="yourProject"
                      [style.border]="
                        isFieldInvalid('yourProject') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="yourProject_5"
                      class="w-full py-4 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Aucun des projets</label
                    >
                  </div>
                </div>
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
                <div class="text-center">
                  <input
                    type="checkbox"
                    id="conditions"
                    class="h-5 w-5 m-3 rounded"
                    formControlName="conditions"
                    value="Accepté"
                    name="conditions"
                    [style.border]="
                      isFieldInvalid('conditions') ? '2px solid #eb1c1c' : ''
                    "
                  />
                  En déposant ma candidature, je m'engage si je suis admis à
                  suivre intégralement le parcours d'accompagnement (les
                  certificats de compétences, le renforcement en employabilité,
                  le développement des compétences transversales ...) . Je
                  certifie que l'ensemble des informations communiquées sont
                  exactes et que toute fausse déclaration m'expose à une
                  exclusion du programme. J'autorise FORCE-N à conserver et à
                  utiliser mes données dans le cadre du programme. Les
                  correspondances, les certificats de réussite, l'accès aux
                  plateformes de formation et les badges seront générés à partir
                  des informations personnelles soumises ci-dessous. Veuillez
                  donc fournir des informations correctes et appropriées
                  <span style="color: red">*</span>
                </div>
              </div>

              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div
                class="flex justify-center items-center"
                *ngIf="allFieldNotSelected"
                style="color: #eb1c1c"
              >
                Veuillez renseigner tous les champs requis!
              </div>
              <div
                class="flex justify-center items-center"
                *ngIf="isSucces"
                style="color: #23eb1c"
              >
                Candidature reussie!
              </div>

              <div class="flex justify-between items-center btn-ctnr">
                <div>
                  <button
                    type="button"
                    class="rounded-md w-48 h-12 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 bg-gray-500"
                    (click)="switchOnPageTwo()"
                  >
                    Retour
                  </button>
                </div>
                <div>
                  <button
                    type="submit"
                    class="rounded-md w-48 h-12 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 btn-login"
                    (click)="onSubmitForm()"
                  >
                    Envoyer
                  </button>
                </div>
              </div>

              <div class="flex justify-center mt-8">
                <div
                  class="logo-icon"
                  style="background-image: url('assets/img/logo_force_n.png')"
                ></div>
              </div>
            </div>
          </form>
        </div>
      </app-card-form>
    </div>
  </div>
</div>
<div
  *ngIf="noSession"
  class="bg-cover bg-center h-screen w-screen"
  style="background-image: url('assets/img/01-BG_AC_Force_N.png')"
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3
              class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400"
            >
              Les candidatures sont closes pour cette session. Restez en contact
              avec nous sur
              <a style="color: blue" href="https://force-n.sn/"
                >https://force-n.sn/</a
              >
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="applied"
  class="bg-cover bg-center h-screen w-screen"
  style="background-image: url('assets/img/01-BG_AC_Force_N.png')"
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3
              class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400"
            >
              Vous avez déjà soumissionné!
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="admission"
  class="bg-cover bg-center h-screen w-screen"
  style="background-image: url('assets/img/01-BG_AC_Force_N.png')"
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3
              class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400"
            >
              Vous étes déja admis dans ce parcour.
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
